import { Injectable } from "@angular/core";
import { PostEntity } from "../../domain/entity";
import {
    InsertPostInputType,
    InsertPostUsecase
} from "@arch/domain/application/usecase/insert-post.usecase";

@Injectable({
    providedIn: "root"
})
export class InsertPostController {
    constructor(private readonly insertPostUsecase: InsertPostUsecase) {}

    public async execute(input: InsertPostInputType): Promise<void> {
        await this.insertPostUsecase.execute(input);
    }
}
